<style lang='less' scoped>
	@import '../base.less';
</style>
<template>
	<div>
		<!-- SEARCH -->
		<!--    -->
		<Row>
			<Col span='24'>
			<Card>
				<Form :model="windowAddItem" :label-width="200" label-position="left">
					<FormItem label='网站名称' prop='titleName'>
						<Input clearable v-model='windowAddItem.titleName' :placeholder="$t('请输入网站标题')"
							style="width: 300px;"></Input>
					</FormItem>
					<FormItem label='域名' prop='domain' style="width: 900px">
						<Input clearable v-model='windowAddItem.domain' :placeholder="$t('请输入网站域名')"></Input>
					</FormItem>


					<FormItem label='网站SEO标题' prop='seoTitle' style="width: 900px">
						<Input clearable v-model='windowAddItem.seoTitle' :placeholder="$t('请输入网站SEO标题')"></Input>
					</FormItem>
					<FormItem label='网站seo关键词' prop='seoKeyword' style="width: 900px">
						<Input clearable v-model='windowAddItem.seoKeyword' :placeholder="$t('请输入网站seo关键词')"></Input>
					</FormItem>
					<FormItem label='网站seo描述' prop='seoDescription' style="width: 900px">
						<Input clearable v-model='windowAddItem.seoDescription' :placeholder="$t('请输入网站seo描述')"></Input>
					</FormItem>

          <FormItem label='图片专属域名'  style="width: 900px">
            <FormItem label='是否使用图片专属地址' prop='showType'>
              <Select clearable v-model="windowAddItem.isUseImgUrl" style='width:200px'>
                <Option  :value='0' >图片放在同目录</Option>
                <Option  :value='1' >图片使用专属域名(需要技术配置)</Option>
              </Select>
              <Input clearable v-model='windowAddItem.imgUrl' :placeholder="$t('请埴写图片专属域名(使用同目录则无需填写)')"></Input>
            </FormItem>
          </FormItem>

          <FormItem label='密钥'  style="width: 900px">
            <p>密钥请填写正确(本系统仅提供内部使用,密钥错误本系统将无法正常工作),每个密钥有数量限制,不能超限部署</p>
            <FormItem style="width: 900px" label='' prop='showType'>
              <Input clearable v-model='windowAddItem.saveKey' :placeholder="$t('请填写由技术人员提供的专属密钥')"></Input>
            </FormItem>
          </FormItem>

          <FormItem label='前台站点域名（不参与生成,仅用于后台显示时使用）' prop='testUrl' style="width: 900px">
            <Input clearable v-model='windowAddItem.testUrl' :placeholder="$t('请输入前台站点域名，只能填一个')"></Input>
          </FormItem>

          <FormItem label='记录前台站点域名（不参与生成,至少填写一个,多个用逗号隔开）' prop='elseUrl' style="width: 900px">
            <Input clearable v-model='windowAddItem.elseUrl' :placeholder="$t('请输入前台站点域名，仅用于记录，不参与生成,多个用小写的逗号隔开')"></Input>
          </FormItem>

					<FormItem label='站点生成目录(非技术人员请匆修改)' prop='path' style="width: 900px">
						<Input clearable v-model='windowAddItem.path' :placeholder="$t('请输入站点生成目录')"></Input>
					</FormItem>


					<FormItem label="网站LOGO" prop="logoUrl">
            <FormItem label='LOGO位置' prop='showType'>
              <Select clearable v-model="windowAddItem.isLogoCenter" style='width:200px'>
                <Option  :value='0' >左侧</Option>
                <Option  :value='1' >居中</Option>
              </Select>
            </FormItem>
            <FormItem label='网站LOGO(链接)' prop='logoUrl'>
              <Input  clearable v-model='windowAddItem.logoUrl' :placeholder="$t('请输入图片的链接地址')"></Input>
            </FormItem>
						<div class="demo-upload-list" v-if="windowAddItem.logoUrl">
							<img :src="windowAddItem.logoUrl" style="max-width: 200px;max-height: 200px">
							<div class="demo-upload-list-cover">
								<Icon type="ios-trash-outline" @click.native="handleImgRemove('logoUrl')"></Icon>
							</div>
						</div>
						<input v-if="windowAddItem.logoUrl" v-model="windowAddItem.logoUrl" type="hidden" name="image">
						<Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!windowAddItem.logoUrl"
							:format="['jpg','jpeg','png','gif']" :max-size="5120" :on-success="v=>{handleImgSuccess(v,'logoUrl')}"
							:on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
							style="display: inline-block;width:58px">
							<div style="width: 58px;height:58px;line-height: 58px">
								<Icon type="md-camera" size="20"></Icon>
							</div>
						</Upload>

					</FormItem>

					<FormItem label="网站首页顶部大LOGO" prop="bigLogo">
            <FormItem label='网站首页顶部大LOGO(链接)' prop='bigLogo'>
              <Input  clearable v-model='windowAddItem.bigLogo' :placeholder="$t('请输入图片的链接地址')"></Input>

            </FormItem>
            <FormItem label='网站首页顶部大LOGO(高度)' prop='bigLogoHeight'>
              <InputNumber clearable v-model='windowAddItem.bigLogoHeight' :placeholder="$t('网站首页顶部大LOGO高度')"></InputNumber>
            </FormItem>
						<div class="demo-upload-list" v-if="windowAddItem.bigLogo">
							<img :src="windowAddItem.bigLogo" style="max-width: 200px;max-height: 200px">
							<div class="demo-upload-list-cover">
								<Icon type="ios-trash-outline" @click.native="handleImgRemove('bigLogo')"></Icon>
							</div>
						</div>
						<input v-if="windowAddItem.bigLogo" v-model="windowAddItem.bigLogo" type="hidden" name="image">
						<Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!windowAddItem.bigLogo"
							:format="['jpg','jpeg','png','gif']" :max-size="5120" :on-success="v=>{handleImgSuccess(v,'bigLogo')}"
							:on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
							style="display: inline-block;width:58px">
							<div style="width: 58px;height:58px;line-height: 58px">
								<Icon type="md-camera" size="20"></Icon>
							</div>
						</Upload>

					</FormItem>



          <FormItem label="网站背景图片" prop="bigBg">
            <FormItem label='网站背景图片(链接)' prop='bigBg'>
              <Input  clearable v-model='windowAddItem.bigBg' :placeholder="$t('请输入图片的链接地址')"></Input>
            </FormItem>
            <div class="demo-upload-list" v-if="windowAddItem.bigBg">
              <img :src="windowAddItem.bigBg" style="max-width: 200px;max-height: 200px">
              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleImgRemove('bigBg')"></Icon>
              </div>
            </div>
            <input v-if="windowAddItem.bigBg" v-model="windowAddItem.bigBg" type="hidden" name="image">
            <Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!windowAddItem.bigBg"
                    :format="['jpg','jpeg','png','gif']" :max-size="5120" :on-success="v=>{handleImgSuccess(v,'bigBg')}"
                    :on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
                    style="display: inline-block;width:58px">
              <div style="width: 58px;height:58px;line-height: 58px">
                <Icon type="md-camera" size="20"></Icon>
              </div>
            </Upload>

          </FormItem>

          <FormItem label="网站favicon" prop="favicon">
            <FormItem label='网站favicon(链接)建议72*72' prop='favicon'>
              <Input  clearable v-model='windowAddItem.favicon' :placeholder="$t('请输入favicon的链接地址')"></Input>
            </FormItem>
            <div class="demo-upload-list" v-if="windowAddItem.favicon">
              <img :src="windowAddItem.favicon" style="max-width: 200px;max-height: 200px">
              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleImgRemove('favicon')"></Icon>
              </div>
            </div>
            <input v-if="windowAddItem.favicon" v-model="windowAddItem.favicon" type="hidden" name="image">
            <Upload type="drag" :action="uploadUrl" :headers="uploadHeader" v-if="!windowAddItem.favicon"
                    :format="['jpg','jpeg','png','gif','ico']" :max-size="5120" :on-success="v=>{handleImgSuccess(v,'favicon')}"
                    :on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
                    style="display: inline-block;width:58px">
              <div style="width: 58px;height:58px;line-height: 58px">
                <Icon type="md-camera" size="20"></Icon>
              </div>
            </Upload>

          </FormItem>

          <FormItem label='网站主色调' prop='mainColor' style="width: 900px">
            <ColorPicker v-model="windowAddItem.mainColor" :placeholder="$t('颜色')" />
          </FormItem>

          <FormItem label='网站次色调' prop='secondColor' style="width: 900px">
            <ColorPicker v-model="windowAddItem.secondColor" :placeholder="$t('颜色')" />
          </FormItem>

          <FormItem label='标题颜色' prop='titleColor' style="width: 900px">
            <ColorPicker v-model="windowAddItem.titleColor" :placeholder="$t('颜色')" />
          </FormItem>


					<FormItem label='选择网站模板' prop='templatePath'>
						<Select clearable v-model="windowAddItem.templatePath" style='width:200px'>
							<Option v-for="item in windowAddItem.template" :value="item.content" :key="item.content">
								{{ item.name }}
							</Option>
						</Select>
					</FormItem>

          <FormItem label='新澳门高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_0' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='香港高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_1' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='老澳门高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_2' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='快乐8高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_3' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='柬埔寨高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_4' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='台湾高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_5' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='印尼高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_6' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>
          <FormItem label='马来西亚高手版一区 二区,帖子广告区数量设定(逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.bbsNums_7' :placeholder="$t('高手版一区 二区,帖子广告区数量设定(逗号隔开)')"></Input>
          </FormItem>



          <FormItem label='选择网站要显示的分类' prop='showGame'>
            <Select clearable multiple v-model="windowAddItem.showGame" style='width:200px'>
              <Option  :value='0' >新澳门</Option>
              <Option  :value='2' >老澳门</Option>
              <Option  :value='1' >香港</Option>
              <Option  :value='7' >快乐8</Option>
              <Option  :value='4' >柬埔寨</Option>
              <Option  :value='5' >台湾</Option>
              <Option  :value='6' >印尼</Option>
              <Option  :value='7' >马来西亚</Option>
            </Select>
          </FormItem>

<!--          <FormItem label='子菜单哪个在前面' prop='showType' v-if="windowAddItem.showType==0">-->
<!--            <Select clearable v-model="windowAddItem.isXgFirst"  style='width:200px'>-->
<!--              <Option  :value='0' >澳门在前</Option>-->
<!--              <Option  :value='1' >香港在前</Option>-->
<!--            </Select>-->
<!--          </FormItem>-->

          <FormItem label='金' prop='j'>
            <Input clearable v-model='windowAddItem.j' :placeholder="$t('请输入今年的金属号码,逗号隔开如 1,2,9,10,23,24,31,32,39,40')"></Input>
          </FormItem>
          <FormItem label='木' prop='m'>
            <Input clearable v-model='windowAddItem.m' :placeholder="$t('请输入今年的金属号码,逗号隔开如 1,2,9,10,23,24,31,32,39,40')"></Input>
          </FormItem>
          <FormItem label='水' prop='s'>
            <Input clearable v-model='windowAddItem.s' :placeholder="$t('请输入今年的金属号码,逗号隔开如 1,2,9,10,23,24,31,32,39,40')"></Input>
          </FormItem>
          <FormItem label='火' prop='h'>
            <Input clearable v-model='windowAddItem.h' :placeholder="$t('请输入今年的金属号码,逗号隔开如 1,2,9,10,23,24,31,32,39,40')"></Input>
          </FormItem>
          <FormItem label='土' prop='t'>
            <Input clearable v-model='windowAddItem.t' :placeholder="$t('请输入今年的金属号码,逗号隔开如 1,2,9,10,23,24,31,32,39,40')"></Input>
          </FormItem>

          <FormItem label='随机颜色(英文逗号隔开)' prop='colors'>
            <Input clearable v-model='windowAddItem.colors' :placeholder="$t('随机颜色(逗号隔开),注意不要以逗号结尾,且逗号为英文半角下的逗号')"></Input>
          </FormItem>
          <FormItem label='随机字符(英文逗号隔开)' prop='symbols'>
            <Input clearable v-model='windowAddItem.symbols' :placeholder="$t('随机字符(逗号隔开),注意不要以逗号结尾,且逗号为英文半角下的逗号')"></Input>
          </FormItem>
          <FormItem label='随机帖子字体(英文逗号隔开)' prop='bbsFont'>
            <Input clearable v-model='windowAddItem.bbsFont' :placeholder="$t('随机帖子字体(逗号隔开),注意不要以逗号结尾,且逗号为英文半角下的逗号')"></Input>
          </FormItem>
          <FormItem label='随机括号(先用|隔开,再用英文逗号隔开)' prop='kuohaos'>
            <Input clearable v-model='windowAddItem.kuohaos' :placeholder="$t('随机括号(先用|隔开,再用逗号隔开),注意不要以逗号结尾,且逗号为英文半角下的逗号')"></Input>
          </FormItem>
          <FormItem label='对错字符(先用|隔开,再用英文逗号隔开)' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.trueTexts' :placeholder="$t('对错字符(先用|隔开,再用逗号隔开),注意不要以逗号结尾,且逗号为英文半角下的逗号')"></Input>
          </FormItem>
          <FormItem label='高手榜标题模板 作者→【<font color="#FF0000">玩法</font>】←签名' prop='bbsTitleTemplate'>
            <Input clearable v-model='windowAddItem.bbsTitleTemplate' :placeholder="$t('高手榜标题模板（必需包含 作者 玩法 签名 三个标签）')"></Input>
          </FormItem>

          <FormItem label='新澳门采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_0' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='香港采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_1' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='老澳门采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_2' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='快乐8采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_3' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='柬埔寨采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_4' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='台湾采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_5' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='印尼采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_6' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>
          <FormItem label='马来西亚采集地址' prop='trueTexts'>
            <Input clearable v-model='windowAddItem.caiUrl_7' :placeholder="$t('采集地址JS')"></Input>
          </FormItem>

          <FormItem label='是否允许远程控制广告' prop='isTerminalAd'>
            <i-switch v-model='windowAddItem.isTerminalAd'
                      :true-value="1" :false-value="0" true-color="#13ce66" />
          </FormItem>


          <FormItem label="JS素材上传" prop="js">
            <FormItem label='JS地址,如果需要上传JS素材文件,可以在这边上传(刷新后消失,请自行复制链接到本地)' prop='js'>
              <Input  clearable v-model='windowAddItem.js' :placeholder="$t('JS地址(刷新后消失,请自行记录)')"></Input>
            </FormItem>
            <div class="demo-upload-list" v-if="windowAddItem.js">

              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleImgRemove('js')"></Icon>
              </div>
            </div>

            <Upload type="drag" :action="uploadUrl" :headers="uploadHeader"
                    :format="['jpg','jpeg','png','gif','js','html']" :max-size="5120" :on-success="v=>{handleImgSuccess(v,'js')}"
                    :on-format-error="handleImgFormatError" :on-exceeded-size="handleImgMaxSize"
                    style="display: inline-block;width:58px">
              <div style="width: 58px;height:58px;line-height: 58px">
                <Icon type="md-camera" size="20"></Icon>
              </div>
            </Upload>

          </FormItem>

					<FormItem label="" style="margin-top:20px">
						<Button type="primary" @click="windowAddSubmit" style="margin-right:10px">确定修改</Button>
					</FormItem>
				</Form>

			</Card>
			</Col>
		</Row>


	</div>
</template>
<script>
	import internationality from '@/components/internationality'
	import {
		urlGet,
		urlEdit
	} from '@/api/Lhc/Lhc'
	import {
		formattingMonth,
		lastMonthDate
	} from '@/libs/time'
	import {
		baseUrl
	} from '@/libs/api.request'
	import {
		getToken
	} from '@/libs/util'

	export default {
		name: 'interface_list',
		data() {
			return {
				uploadUrlCk: baseUrl + 'Index/uploadCk',
				uploadUrl: baseUrl + 'Index/upload',
				uploadHeader: {
					'Authorization': "bearer " + getToken()
				},
				timeOptions: {
					shortcuts: [{
							text: '今天',
							value() {
								let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
								let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
									1000 - 1)
								return [a, b]
							}
						},
						{
							text: '昨天',
							value() {
								let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
									1000)
								let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
									1000 + 24 * 60 *
									60 * 1000 - 1)
								return [a, b]
							}
						},
						{
							text: '一周',
							value() {
								let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 *
									1000 * 7)
								let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 *
									1000 - 1)
								return [a, b]
							}
						},
						{
							text: '本月',
							value() {
								return formattingMonth()
							}
						},
						{
							text: '上月',
							value() {
								return lastMonthDate()
							}
						},
					]
				},
				columnsList: [],
				tableData: [], //用于放LIST数据绑定
				tableShow: { //用于分页
					currentPage: 1,
					pageSize: 10,
					listCount: 0
				},
				searchConf: {
					searchTime: [],
				}, // 搜索字段
				extraParams: [],
				buttonShow: { //按钮状态显示
					edit: true,
					del: true,
					changeStatus: true
				},
				listLoading: false, //显示加载中状态
				//弹窗--------------
				windowAdd: { //弹窗
					show: false,
					loading: false,
					index: 0
				},
				windowAddItem: { //弹窗数据绑定
					id: 0,
					logo: '',
					templatePath: '',
          js:""
				},
				windowAddValidate: { //窗口校验规则
				}, //----------------
			}
		},
		components: {
			internationality
		},
		created() {
			let vm = this
			vm.getList()
			vm.hasRule('systemManage/siteSetting/edit').then(res => {
				vm.buttonShow.edit = res
			})
			vm.hasRule('systemManage/siteSetting/del').then(res => {
				vm.buttonShow.del = res
			})
			vm.hasRule('systemManage/siteSetting/changeStatus').then(res => {
				vm.buttonShow.changeStatus = res
			})
		},
		mounted() {
			this.getParams()
		},
		methods: {
			preAdd() {
				let vm = this
				vm.windowAdd.show = true
			},
			getParams() {
				// getParams().then(response => {
				//     this.extraParams = response.data.data
				// })
			},
			changePage(page) {
				this.tableShow.currentPage = page
				this.getList()
			},
			changeSize(size) {
				this.tableShow.pageSize = size
				this.getList()
			},
			search() {
				this.tableShow.currentPage = 1
				this.getList()
			},
			getList() {
				let vm = this
				vm.listLoading = true
				urlGet({
					page: 1,
				}).then(response => {
					vm.windowAddItem = response.data.data
				})
			},

			timeChange(datetimerange) { //时间修改，自动计算尾部时间
				if (datetimerange[0] !== '' && datetimerange[1] !== '') {
					let patt = /00:00:00/
					this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
					if (patt.test(datetimerange[1])) {
						datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
						this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
					}
				} else {
					this.searchConf.searchTime = []
				}
			},
			sortChange: function({
				column,
				key,
				order
			}) {
				//order值可能为asc,desc,normal
				this.searchConf.order = [key, order]
				if (order == 'normal') {
					this.searchConf.order = []
				}
				this.getList()
			},
			windowAddCancel(data) {
				if (!data) {
					this.windowAddItem.id = 0
					this.$refs['windowAddForm'].resetFields()
					this.windowAdd.show = false
					this.windowAdd.loading = false
					this.windowAdd.index = 0
				}
			},
			windowAddSubmit() {
				let vm = this
				vm.windowAdd.loading = true

				console.log(vm.windowAddItem)
				urlEdit(vm.windowAddItem).then(response => {
					vm.$Message.success(response.data.msg)
					vm.getList()
					vm.windowAddCancel()
				}).catch(() => {
					vm.windowAdd.loading = false
				})

			},
			handleImgFormatError(file) {
				this.$Notice.warning({
					title: '文件类型不合法',
					desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
				})
			},
			handleImgRemove(key) {
				this.windowAddItem[key] = ''
			},
      handleImgSuccess(response,key) {
        if (response.code === 1) {
          this.$Message.success(response.msg)
          if (response.data.fileUrl.startsWith('http')) {
            this.windowAddItem[key] = response.data.fileUrl
          } else {
            this.windowAddItem[key] = response.data.showUrl
            console.log( this.windowAddItem.js)
            this.$forceUpdate();
          }
        } else {
          this.$Message.error(response.msg)
        }
      },
			handleImgMaxSize(file) {
				this.$Notice.warning({
					title: '文件大小不合法',
					desc: file.name + '太大啦请上传小于5M的文件。'
				})
			},
		}
	}
</script>
